var map = {
	"./biology.json": [
		"41Tg",
		68
	],
	"./carousel.json": [
		"W0Q0",
		9
	],
	"./chemistry.json": [
		"MNbi",
		67
	],
	"./computer.json": [
		"LAX/",
		66
	],
	"./directors.json": [
		"RH1C",
		8
	],
	"./dormStaff.json": [
		"46qI",
		65
	],
	"./engineering.json": [
		"3G8M",
		64
	],
	"./english.json": [
		"hVcZ",
		63
	],
	"./health.json": [
		"bzVg",
		62
	],
	"./history.json": [
		"F1Rq",
		61
	],
	"./index.json": [
		"hADh",
		7
	],
	"./maths.json": [
		"GcX/",
		60
	],
	"./modal.json": [
		"76Tf",
		6
	],
	"./officers.json": [
		"jOUd",
		59
	],
	"./physics.json": [
		"LxqP",
		58
	],
	"./psychologist.json": [
		"x432",
		57
	],
	"./staff.json": [
		"av2I",
		5
	],
	"./thai.json": [
		"COUR",
		56
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "u2aI";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/json/en/staff lazy ^\.\/.*\.json$
// module id = u2aI
// module chunks = 82